import Vue from "vue";

const requireComponent = require.context("@/components", true, /\.vue$/);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);

  const rawName = fileName.replace(/^\.\//, "").replace(/\.\w+$/, "");

  const componentName = rawName
    .split(/[\/\-_]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join("");

  Vue.component(componentName, componentConfig.default || componentConfig);
});
